module.exports = __webpack_public_path__ + "img/outlinedCheck.97c7a6f5.png";